<template lang="pug">
  section.TopInformation
    // Meteor(v-show="isBigDataOps")
    // constellation(v-show="isAIOps")
    // triangle(v-show="isIotOps")
    // constellation(v-show="isMarketOps" :original-points="marketConstellation")
    // rotate(v-show="isMarketOps")
    // constellation(v-show="isRecommendationOps" :original-points="recommendationConstellation")
    .background(:class="nowOps.backgroundClass")
    .information
      h1 {{ nowOps.title }}
      h2 {{ nowOps.subTitle }}
      p {{ nowOps.text }}
      button.linkBtn(class="bigLinkBtn" @click="gotoExperience") 立即体验

</template>

<script>
  import Mixin from "../index.js";
  import Meteor from "@/components/Meteor";
  import Constellation from "@/components/Constellation";
  import Triangle from "@/components/triangle";
  import Rotate from "@/components/rotate";
  
  export default {
    name: "TopInformation",
    components: {Rotate, Triangle, Constellation, Meteor},
    mixins: [Mixin],
    data() {
      return {
        marketConstellation: [
          [
            {x: 800, y: 140, arc: 1},
            {x: 823, y: 154, arc: 1},
            {x: 853, y: 146, arc: 1},
            {x: 874, y: 162, arc: 1.2},
            {x: 894, y: 153, arc: 1},
          ],[
            {x: 1650, y: 521, arc: 1},
            {x: 1660, y: 496, arc: 1},
            {x: 1680, y: 520, arc: 1},
            {x: 1692, y: 496, arc: 1.2},
            {x: 1720, y: 494, arc: 1},
          ],
        ],
        recommendationConstellation: [
          [
            {x: 805, y: 157, arc: 1},
            {x: 830, y: 171, arc: 1},
            {x: 849, y: 127, arc: 1},
            {x: 810, y: 128, arc: 1.2},
            {x: 853, y: 146, arc: 1},
          ],
        ],
      };
    },
    methods: {
      gotoExperience() {
        this.$router.push({name: 'GuestForm'})
      }
    }
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  @import "../../../assets/css/main.styl"
  .TopInformation {
    width 100%
    height (600 / 1920) * 100vw
    position relative
    /*min-height 600px*/
    .background {
      position absolute
      top 0
      left 0
      height (600 / 1920) * 100vw
      width 100%
      background-repeat no-repeat
      background-position center
      background-color #252525
      background-size 100%
    }
    .information {
      position absolute
      margin-left 14.479%
      margin-top 9.0625%
    }
    
    h1, h2, p, button {
      color white
      text-shadow 0 2px 4px rgba(0, 0, 0, .4)
    }
    
    h1 {
      font-size (48 / 14)rem
      FontSetting("思源黑体 CN Heavy")
      margin-bottom 0
      padding-bottom 0
    }
    
    h2 {
      font-size (28 / 14)rem
      FontSetting("思源黑体 CN Regular")
      margin-top 0
      padding-top 0
      margin-bottom 40px
    }
    
    p {
      margin-top 0
      padding-top 0
      font-size (14 / 14)rem
      FontSetting("思源黑体 CN Regular")
      line-height 26px
    }
    
    
    .bigLinkBtn {
      height 48px
      width 168px
      border-radius 48px
      box-sizing border-box
      HStack(center, center)
      margin-top 60px
    }
    @media (max-width 1920px) {
      height 600px
      .background {
        height 600px
        background-size auto 100%
      }
    }
  }
  
  canvas {
    position absolute
  }

  .BD-background {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E5%A4%A7%E6%95%B0%E6%8D%AEOPSbanner.png")
  }

  .AI-background {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/AI%20OPS%20banner.png")
  }

  .IoT-background {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/IoT%20OPS%20banner.png")
  }

  .Marketing-background{
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E7%B2%BE%E5%87%86%E8%90%A5%E9%94%80banner.png")
  }

  .Recommendation-background {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E6%99%BA%E8%83%BD%E6%8E%A8%E8%8D%90banner.png")
  }

  @media (max-width ipadProScreenWidth) {
    .TopInformation {
      .background {
        background-size auto 100%
      }
      .information {
        bottom 0
        margin-bottom 60px
        margin-left 60px
        margin-top auto
      }
    }
  }
  @media (max-width screenWidth) {
    .TopInformation {
      width 100vw
      height 500px
      position relative
      .background {
        height 500px
        background-size auto 100%
        background-position-y bottom
        filter brightness(60%)
      }
      .bigLinkBtn {
        margin-top 30px
      }
      .information {
        margin-top 150px
        margin-left 0
        padding 0 50px
        h1 {
          font-size 32px
          padding 0
        }
        h2 {
          font-size 16px
        }
        p {
          font-size 12px
          color rgba(#fff, .7)
        }
      }
      .BD-background {
        background-position-x -950px
      }
      .AI-background {
        background-position-x -1050px
      }
      .IoT-background {
        background-position-x -932px
        filter brightness(70%)
      }
      .Marketing-background {
        background-position-x -888px
        filter brightness(90%)
      }
      .Recommendation-background {
        background-position-x -950px
      }
    }
  }
  
</style>
